import React from 'react';
import classNames from 'classnames/bind';

import Styles from './EmptyState.styles';
import Image from './empty-tests.png';
import trackEvent, { DOCUMENTATION_EVENTS } from './../../tracking';

const context = classNames.bind(Styles);

const RdcJobsEmptyState = () => (
  <div className={context('empty-state')}>
    <h3 style={{ backgroundImage: `url(${Image})` }}>Run your local Appium tests on Sauce</h3>
    <p>
      {"Simply change the remote address of the Appium driver and add capabilities. That's all."}
      <br />
      {'Please refer to our documentation for a '}
      <a
        href="https://wiki.saucelabs.com/display/DOCS/Getting+Started+with+Appium+for+Mobile+Application+Testing"
        onClick={() => {
          trackEvent(DOCUMENTATION_EVENTS.RDC_TESTS);
        }}
        rel="noopener noreferrer"
        target="_blank"
      >
        detailed introduction
      </a>
      {'.'}
    </p>
  </div>
);

export default RdcJobsEmptyState;
